import { IFormValues } from "../types/types";

export const getIndex = (values: IFormValues) => {
  const pagesIndex: number[] = [];
  values?.schema?.filter(
    (item, index) => item.component.type === "page" && pagesIndex.push(index)
    );
    let schemaLength = values?.schema[values?.schema?.length - 1];
    let schemaFinalIndex = values?.schema?.indexOf(schemaLength);
    pagesIndex.push(schemaFinalIndex + 2);

  return {
    pagesIndex,
  };
};
